export type ProductCategory = 'insurance' | 'finance' | 'hr' | 'shops' | 'travel';

export type Product = {
    key: string;
    title: string;
    sub: string;
    reward: string;
    icon: 'car' | 'house' | 'leaf' | 'globe' | 'carCrash';
    cat: ProductCategory;
    isNew?: boolean;
    href?: string;
    wiki?: string;
    /** Не показывать в витрине (раздел не готов); код раздела не трогаем. */
    hidden?: boolean;
};

export const PRODUCTS: Product[] = [
    {
        key: 'osago',
        title: 'ОСАГО',
        sub: 'Водителям авто — обязательное страхование автогражданской ответственности',
        reward: '0–35%',
        icon: 'car',
        cat: 'insurance',
        href: '/osago',
        wiki: '/wiki/osago/',
    },
    {
        key: 'ipoteka',
        title: 'Ипотека',
        sub: 'Страхование жизни и имущества для заёмщиков по ипотеке',
        reward: '6–55%',
        icon: 'house',
        cat: 'insurance',
        href: '/ipoteka',
        wiki: '/wiki/ipoteka/',
    },
    {
        key: 'kasko',
        title: 'КАСКО',
        sub: 'Страхование авто от любых повреждений и хищений — мини или полное',
        reward: '10–39%',
        icon: 'car',
        cat: 'insurance',
        href: '/kasko-insapp',
        wiki: '/wiki/kasko/',
    },
    {
        key: 'property',
        title: 'Страхование недвижимости',
        sub: 'Квартира: отделка, движимое имущество и ответственность перед соседями',
        // Диапазон КВ — по реальным офферам витрины ИФЛ на 12.08.2026.
        reward: '32–50%',
        icon: 'house',
        cat: 'insurance',
        isNew: true,
        href: '/property',
        // Скрыт 04.11.2026: раздел не готов (team index/property-insurance-hide-section).
        hidden: true,
    },
    {
        key: 'antiklesh',
        title: 'Антиклещ',
        sub: 'Страхование от укуса клеща: экстренная помощь и лечение',
        reward: '20–40%',
        icon: 'leaf',
        cat: 'insurance',
        href: '/mite',
    },
    {
        key: 'travel',
        title: 'Страхование путешествий',
        sub: 'Туристам в поездках по России и за границу — ВЗР и медпомощь',
        reward: '20–50%',
        icon: 'globe',
        cat: 'insurance',
        href: '/travel-cherehapa',
    },
];

export const CATEGORIES: Array<{
    value: ProductCategory;
    label: string;
    disabled?: boolean;
    hint?: string;
}> = [
    { value: 'insurance', label: 'Страховые' },
    { value: 'finance', label: 'Финансовые', disabled: true, hint: 'скоро' },
    { value: 'hr', label: 'Подбор персонала', disabled: true },
    { value: 'shops', label: 'Магазины', disabled: true },
    { value: 'travel', label: 'Путешествия', disabled: true },
];
